<template>
  <div class="pa-0 ma-0" v-if="navig">
    <!-- <FsLightbox :toggler="toggler" :sources="images" /> -->
    <v-row no-gutters>
      <v-col class="overflow-y-auto">
        <!-- <iframe style="border-radius:12px"
        src="https://open.spotify.com/embed/playlist/1goHyqIPtM76ueBvyooP0j?utm_source=generator&theme=0" width="100%"
        height="352" frameBorder="0" allowfullscreen=""
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe> -->
        <v-row no-gutters>
          <v-img height="100vh" width="100%" :src="`${userData.image}`" :lazy-src="`${userData.image}`"
            alt="No Profile Image Found"
            :gradient="`${routeLink}` == 'straight' ? 'to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,1)' : `${routeLink}` == 'gay' ? 'to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,145,236,1)' : `${routeLink}` == 'lesbian' ? 'to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(69,17,81,1)' : ''">
            <div
              class="drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] absolute md:bottom-10 bottom-7 left-7 md:left-10 text-white"
              v-motion :initial="{ opacity: 0, y: 100 }" :enter="{
                opacity: 1, y: 0, transition: {
                  duration: 400,
                  type: 'keyframes',
                  ease: 'backInOut',
                },
              }" :delay="300">
              <div class="flex items-center gap-2">
                <h3
                  class="text-3xl font-normal leading-10 sm:text-4xl md:text-5xl font-Handel capitalize user_name_animation">
                  {{ userData.name }}

                </h3>
                <v-tooltip top :color="colorAsRoute">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn rounded small fab class="  font-Handel !text-[#b19141]" color="black" dark v-on="on"
                      v-bind="attrs">
                      <v-icon :color="colorAsRoute">
                        {{ premium ? "mdi-crown-outline" : "mdi-seal" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span class="text-black">{{ (premium ? "Premium Member" : "Basic Member") }}</span>
                </v-tooltip>
              </div>
              <h3 class="text-xl font-Handel capitalize user_name_animation">
                {{ userData.age }}y ,
                {{ userData.location }}
              </h3>
            </div>
          </v-img>
        </v-row>

        <!-- Profile Author Name -->

        <div class="bg-gradient-to-b from-black to-transparent font-Handel p-3 ">
          <v-row class="px-4 py-2">
            <v-col cols="12" v-motion :initial="{ opacity: 0, y: 100 }" :visible="{
              opacity: 1, y: 0, transition: {
                duration: 400,
                type: 'keyframes',
                ease: 'backInOut',
              },
            }">
              <h3 class="text-2xl font-semibold font-Nunito capitalize">
                <span :class="`${routeLink}_text_color`">BIO</span> {{ userData.name }}
              </h3>
            </v-col>
            <v-divider />
            <v-col cols="12">
              <v-list dense color="transparent" class="">
                <v-list-item class="text-white pa-0" v-motion-pop-visible>
                  <v-list-item-icon>
                    <v-icon :color="colorAsRoute">mdi-book-education</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="!text-lg font-Handel !capitalize">{{ userData.education }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="text-white pa-0" v-motion-pop-visible>
                  <v-list-item-icon>
                    <v-icon :color="colorAsRoute">mdi-map-marker-multiple</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="!text-lg font-Handel !capitalize">{{ userData.partner_age_range }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="text-white pa-0" v-motion-pop-visible>
                  <v-list-item-icon>
                    <v-icon :color="colorAsRoute">mdi-briefcase</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="!text-lg font-Handel !capitalize">{{ userData.job }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-divider />
            <v-col cols="12" v-motion :initial="{ opacity: 0, y: 100 }" :visible="{
              opacity: 1, y: 0, transition: {
                duration: 400,
                type: 'keyframes',
                ease: 'backInOut',
              },
            }">
              <h3 class="text-xl  font-Handel my-2">
                <span class="text-slate-300">Hobbies :</span>
              </h3>
              <div class="hobbies">
                <v-chip close close-icon="mdi-delete" @click:close="deleteHobbies(item.id)"
                  :class="`ma-2 hover:scale-110 !duration-500 font-Handel !transition-transform text-black ${routeLink}_color`"
                  :color="`${routeLink}` == 'straight' ? '#cba440' : `${routeLink}` == 'gay' ? '#78a8f4' : `${routeLink}` == 'lesbian' ? '#a032f5' : ''"
                  v-for="item in userData.user_intrests" :key="item.key">
                  <v-icon v-show="interestdltLoading" left :class="{ 'spinner': interestdltLoading }">mdi-loading</v-icon>
                  {{ item.interest.title }}
                </v-chip>
              </div>
              <!-- <div v-else>
                <v-chip class="ma-2 primary--text" color="black" v-for="(item, idx) in localHobbies" :key="idx">{{ item
                }}</v-chip>
              </div> -->
            </v-col>
            <v-divider />
            <v-col cols="12" v-motion :initial="{ opacity: 0, y: 100 }" :visible="{
              opacity: 1, y: 0, transition: {
                duration: 400,
                type: 'keyframes',
                ease: 'backInOut',
              },
            }">
              <h3 class="text-xl  font-Handel my-2">
                <span class="text-slate-300">About :</span>
              </h3>
              <p class="text-sm !font-Handel break-words">
                {{
                  userData.about
                }}
              </p>
            </v-col>
          </v-row>

          <h3 class="text-xl  font-Handel my-2 px-3">
            <span class="text-slate-300">Gallery Images :</span>
          </h3>
          <v-row class="py-2" no-gutters>

            <v-col v-for="(item, idx) in userData.user_images" :key="item.id" cols="4"
              class="pa-1 relative group !cursor-pointer" v-motion :initial="{ opacity: 0, y: 100 }" :visible="{
                opacity: 1, y: 0, transition: {
                  duration: 400,
                  type: 'keyframes',
                  ease: 'backInOut',
                  delay: `${idx}00`
                },
              }">


              <v-icon
                class="!z-30 hover:scale-110 !cursor-pointer !absolute !top-2 left-2  rounded-full p-1 bg-black !opacity-0  group-hover:!opacity-100 "
                :class="{ 'spinner': imageDltloading }" small :color="colorAsRoute" @click="deleteImage(item.id)">
                {{ !imageDltloading ? 'mdi-delete' : 'mdi-loading' }}
              </v-icon>


              <div class="absolute top-0 left-0 z-20 w-full h-[85%]" @click="showMultiple(idx)"></div>
              <v-img :src="item.image" :lazy-src="item.image" aspect-ratio="1"
                gradient="to top, rgba(0,0,0,1), rgba(0,0,0,0)" class="grey lighten-2">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
                <template v-slot:default>
                  <div class="grid w-full h-full grid-flow-col align-items-end ">
                    <v-btn text dark :color="checkLiked(item) ? colorAsRoute : ''" @click.prevent="likeSetter(item)"
                      class="!opacity-0 group-hover:!opacity-100">
                      <v-icon :color="checkLiked(item) ? colorAsRoute : ''" small>mdi-thumb-up</v-icon><span
                        v-if="item.likes_count > 0" class="ml-2">{{ item.likes_count }}</span>
                    </v-btn>
                    <v-btn text dark :color="checkLoved(item) ? colorAsRoute : ''" @click.prevent="loveSetter(item)"
                      class="!opacity-0 group-hover:!opacity-100">
                      <v-icon :color="checkLoved(item) ? colorAsRoute : ''" small>mdi-heart</v-icon><span
                        v-if="item.loves_count > 0" class="ml-2">{{ item.loves_count }}</span>
                    </v-btn>
                  </div>
                </template>
              </v-img>
            </v-col>
            <v-row
              class="!h-[calc(50vh-120px)] bg-black !m-2 rounded-3xl !animate-pulse !grid place-items-center font-Handel text-xl "
              v-if="!userData.user_images.length > 0">
              No Images
            </v-row>


          </v-row>

        </div>
        <!-- Profile Author Image End -->
      </v-col>
    </v-row>
    <VueEasyLightbox moveDisabled :visible="visible" :imgs="images" :index="index" @hide="handleHide">
    </VueEasyLightbox>
  </div>
</template>

<script>
import axios from "axios";
import FsLightbox from "fslightbox-vue";
import VueEasyLightbox from 'vue-easy-lightbox'
import VueRain from "./VueRain.vue";

export default {
  name: "Left",
  components: {
    FsLightbox,
    VueRain,
    VueEasyLightbox
  },
  props: {
    navig: {
      type: Boolean,
      default: true,
      required: true,
    },
  },
  computed: {

    premium() {
      return this.$store.getters.isPremium;
    },
    userData() {
      return this.$store.getters.StateUser.data;
    },
    interest() {
      return this.$store.getters.StateUser.user_intrests;
    },
    colorAsRoute() {
      if (this.routeLink == 'straight') {
        return '#a07a1d'
      }
      else if (this.routeLink == 'gay') {
        return '#88c3fa'
      }
      else if (this.routeLink == 'lesbian') {
        return '#9e2eec'
      }
    }
  },
  data() {
    return {
      // Img Url , string or Array
      visible: false,
      imageDltloading: false,
      interestdltLoading: false,
      index: 0,  // defaults
      toggler: true,
      localHobbies: [
        "Travel",
        "Hiking",
        "Running",
        "Camping",
        "Cooking",
        "Kayaking",
        "Cycling",
        "Hunting",
        "Listening to Music",
        "Singing",
        "Gaming",
        "Sports",
        "Shopping",
        "Photography",
        "Painting",
        "Scuba diving",
      ],
      // userDataList: [
      //   { icon: "mdi-book-education", text: "Bachelor of Science" },
      //   { icon: "mdi-map-marker-multiple", text: "Less than a mile" },
      //   { icon: "mdi-briefcase", text: "Software Engineer" },
      // ],
      images: [],

    };
  },
  created() {

  },
  methods: {
    async likeSetter(image) {
      try {
        const resp = await axios.post('users/like/image', {
          image_id: image.id,
          user_id: this.$store.getters.StateUser.data.id
        })
        if (resp.status == 200) {
          const { data } = await axios.get('profiles')
          this.$store.commit("setUser", data);
        }
      } catch (error) {
        console.log(error.response.data.message)
        await this.$store.dispatch("errorAction", error.response.data.message, {
          root: true,
        })
      }
    },
    async loveSetter(image) {
      try {
        const resp = await axios.post('users/love/image', {
          image_id: image.id,
          user_id: this.$store.getters.StateUser.data.id
        })
        if (resp.status == 200) {
          const { data } = await axios.get('profiles')
          this.$store.commit("setUser", data);
        }
      } catch (error) {
        console.log(error.response.data.message)
        await this.$store.dispatch("errorAction", error.response.data.message, {
          root: true,
        })
      }
    },
    checkLiked(item) {
      if (item.liked_by) {
        return true;
      } else {
        const userId = this.$store.getters.StateUser.data.id;
        return item.likes.find(e => e.liked_by == userId)
      }
    },
    checkLoved(item) {
      if (item.loved_by) {
        return true;
      } else {
        const userId = this.$store.getters.StateUser.data.id;
        return item.loves.find(e => e.loved_by == userId)
      }
    },
    async deleteHobbies(interestId) {
      const formData = new FormData()
      formData.append("is_delete_interests[]", interestId);
      try {
        this.interestdltLoading = true;
        const resp = await axios({
          method: "post",
          url: "update-profile",
          data: formData,
        });
        this.$store.commit("setUser", resp.data);
      } catch (error) {
        console.log(error);
      }
      finally {
        this.interestdltLoading = false;
      }
    },

    async deleteImage(imageId) {
      const formData = new FormData()
      formData.append("is_delete_images[]", imageId);
      try {
        this.imageDltloading = true;
        const resp = await axios({
          method: "post",
          url: "update-profile",
          data: formData,
        });
        this.$store.commit("setUser", resp.data);
      } catch (error) {
        console.log(error);
      }
      finally {
        this.imageDltloading = false;
      }
    },

    showMultiple(idx) {
      this.images = this.userData.user_images.map((item) => item.image)
      this.index = idx  // index of imgList
      this.show()
    },
    show() {
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
  },
};
</script>

<style scoped>
.straight_text_color {

  color: #a07a1d;
}

.gay_text_color {
  color: #88c3fa;
}

.lesbian_text_color {
  color: #9e2eec;
}

.spinner {
  animation: spin 0.5s linear infinite;
}

@-webkit-keyframes spin {
  from {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(360deg)
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg)
  }

  to {
    transform: rotate(360deg)
  }
}

.straight_color {
  /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
  background: rgb(177, 145, 65);
  background: linear-gradient(180deg,
      rgb(97 69 0) 0%,
      rgba(202, 174, 112, 1) 53%,
      rgb(90 64 0 / 97%) 100%) !important;
}

.lesbian_color {
  background: rgb(126, 0, 157);
  background: linear-gradient(180deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%) !important;
}

.gay_color {
  background: rgb(0, 240, 255);
  background: linear-gradient(180deg,
      rgba(0, 240, 255, 1) 0%,
      rgba(0, 156, 255, 1) 100%) !important;
}
</style>
